import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, FormGroup, Label, Input, Col, Row } from 'reactstrap'
import moment from 'moment'
import 'moment/locale/ru'
import { withNamespaces } from 'react-i18next'

import { setFilterDate, setActiveProperty } from '../../../ducks/chart'
import { selectActiveState } from '../../../ducks/states'
import Chart from '../../Dashboard/Chart'
import NewsList from '../../Dashboard/NewsList'
import InteractionsPreviewList from '../../Dashboard/InteractionsPreviewList'
import MobilePropertySelect from '../../MobilePropertySelect'
import StyledLabelValue from '../../../components/UI/StyledLabelValue'

import Filters from '../../Dashboard/Filters'

class MainPage extends Component {
  componentDidMount() {
    this.props.selectActiveState(0, false, false)
  }

  render() {
    return (
      <Row>
        <Col xs={12}>
          <Filters />
          <Row>
            <InteractionsPreviewList />
          </Row>
          <Row>
            <Chart />
            <NewsList />
          </Row>
          {/* <NewsList /> */}
        </Col>
      </Row>
    )
  }

  renderMonthButtons = () => {
    const { i18n } = this.props
    const { currentDate, selectedDate, loading } = this.props.chart
    const previousMonth = moment(selectedDate).subtract(1, 'month')
    const nextMonth = moment(selectedDate).add(1, 'month')

    return (
      <div className="d-flex justify-content-between">
        <Button
          disabled={loading}
          outline
          color="secondary"
          onClick={() => this.props.setFilterDate(previousMonth)}
        >
          <FontAwesomeIcon icon="arrow-left" />{' '}
          {previousMonth.locale(i18n.language).format('MMMM YYYY')}
        </Button>
        {nextMonth.isSameOrBefore(currentDate, 'month') && (
          <Button
            disabled={loading}
            outline
            color="secondary"
            onClick={() => this.props.setFilterDate(nextMonth)}
          >
            {nextMonth.locale(i18n.language).format('MMMM YYYY')}{' '}
            <FontAwesomeIcon icon="arrow-right" />
          </Button>
        )}
      </div>
    )
  }

  handlePropertySelect = (ev) => {
    const { value } = ev.target
    this.props.setActiveProperty(value)
  }
}
export default compose(
  connect(
    (state) => ({
      properties: state.properties,
      chart: state.chart
    }),
    { setActiveProperty, setFilterDate, selectActiveState }
  ),
  withNamespaces()
)(MainPage)
